import { XUtils } from '../common/globals'
import { isString } from './base'
import { KAccount } from '../models/k-user'

const { isNumber } = XUtils

// 格式化用户信息：基础信息
export function formatUser(user) {
  const { uid, nick, isRealName, isValidMobile } = user
  // 基本
  user.uid = uid > 0 ? +uid : 0
  user.nick = isString(nick) ? nick : `${user.uid}`
  user.isRealName = isRealName > 0 ? +isRealName : 0
  user.isValidMobile = isValidMobile > 0 ? +isValidMobile : 0

  // 头像
  const logo = user.logo || {}
  let { thumb120, thumb50, thumb, src } = logo
  src = src || ''
  thumb = thumb || src
  thumb50 = thumb50 || thumb
  thumb120 = thumb120 || thumb50
  user.thumb = thumb
  user.thumb50 = thumb50
  user.thumb120 = thumb120
  user.logoSrc = user.thumb120 = thumb120
  user.logoPid = logo.pid > 0 ? logo.pid : 0

  // 会员等级
  const { stageLevel } = user
  if (stageLevel) {
    let { stage, level } = stageLevel
    stage = stage > 0 ? +stage : 0
    level = level > 0 ? +level : 0
    user.stage = stage
    user.level = level
  } else {
    user.stage = 0
    user.level = 0
  }
  return user
}

// 格式化用户信息：账号信息
export function formatAccount(user) {
  user = KAccount(user)
  return user
}

/**
 * 修正浮点数精确位数
 * @param {number} number 待修正数字
 * @param {[number]} fixLength  浮点数精确位数
 * @return {number}  返回修正后的数字
 */
export function fixNumber(number, fixLength) {
  fixLength = fixLength > 0 ? fixLength : fixLength === 0 ? 0 : 2
  number = (+number).toFixed(fixLength)
  number = +number
  return number
}

/**
 * 根据数字正负来显示不同颜色
 * @param {number|string} number 待处理数字
 * @param {[number]} statusNumber  区分数字红绿状态：负-绿、 非负-红
 *   | {number} 数字正负状态
 * @param {[boolean|string]} charSign 非负数前是否显示"+"号
 *   |- true : 非负数前显示"+"号
 *   |- "+"  : 非负数前显示"+"号
 *   |- 其它  : 非负数前不显示"+"号
 * @return {string}  返回数字对应颜色的HTML代码
 */
export function colorNumber(number, statusNumber, charSign) {
  var sign = 0,
    colorStatus,
    html
  if (isNumber(statusNumber)) {
    sign = statusNumber
  } else {
    sign = parseFloat(number)
  }
  if (
    charSign === '+' ||
    charSign === true ||
    statusNumber === '+' ||
    statusNumber === true
  ) {
    charSign = sign >= 0 ? '+' : ''
  } else {
    charSign = ''
  }
  number = charSign + number
  colorStatus = sign >= 0 ? 'rise' : 'fall'
  html = '<span class="cl_' + colorStatus + '">' + number + '</span>'
  return html
}

/**
 * 根据比率数字(如：收益率)正负来显示不同颜色
 * @param {number|string} rateValue 待处理比率浮点数
 * @param {[number]} statusNumber  区分数字红绿状态：负-绿、 非负-红
 *   | {number} 数字正负状态
 * @param {[boolean|string]} charSign 非负数前是否显示"+"号
 *   |- true : 非负数前显示"+"号
 *   |- "+"  : 非负数前显示"+"号
 *   |- 其它  : 非负数前不显示"+"号
 * @return {string}  返回比率浮点数转化为百分比，其对应颜色的HTML代码
 */
export function colorRate(rateValue, stNumber, charSign) {
  rateValue = +rateValue
  if (isNumber(stNumber)) {
    if (!charSign) {
      if (stNumber === '+' || stNumber === true) {
        charSign = stNumber
      }
    }
    stNumber = rateValue
  } else {
    stNumber = rateValue >= 0 ? 1 : -1
  }
  rateValue = htmlRate(rateValue)
  return colorNumber(rateValue, stNumber, charSign)
}

/**
 * 比率转化为百分比HTML代码片段
 * @param {number|string} rateValue 待处理比率浮点数
 * @return {string}  返回比率浮点数转化为百分比，其对应的HTML代码片段
 */
export function htmlRate(rateValue) {
  if (rateValue === Infinity || rateValue === -Infinity || isNaN(rateValue)) {
    rateValue = 0
  }
  rateValue =
    '<span class="rate_num">' +
    (rateValue * 100).toFixed(2) +
    '</span><span class="rate_per">%</span>'
  return rateValue
}

/**
 * 比率转化为百分比字符串
 * @param {number|string} rateValue 待处理比率浮点数
 * @return {string}  返回比率浮点数转化为百分比的字符串
 */
export function textRate(rateValue, fixNumber) {
  if (rateValue === Infinity || rateValue === -Infinity || isNaN(rateValue)) {
    rateValue = 0
  }
  fixNumber = +fixNumber
  fixNumber = fixNumber >= 0 ? fixNumber : 2
  rateValue = (rateValue * 100).toFixed(fixNumber)
  return rateValue
}

/**
 * 数字转化为字符串，万以下自动转化为带【万】【亿】单位
 * @param {number|string} rateValue 待处理数字
 * @param {number} fixLength 浮点为数精确位数，万以上的数字最多精确2位
 * @param {boolean} isHtmlUnint 是否为HTML单位
 * @return {string}  转化后的文本数字
 */
export function textNumber(number, fixLength, isHtmlUnint) {
  var absNumber = Math.abs(number),
    unit = ''
  number = +number || 0

  if (XUtils.isBoolean(fixLength)) {
    isHtmlUnint = fixLength
    fixLength = -1
  } else {
    isHtmlUnint = isHtmlUnint === true
    fixLength = +fixLength
  }

  if (absNumber >= 1000000000000) {
    number = number / 1000000000000
    unit = isHtmlUnint ? '<span class="num_unit">万亿</span>' : '万亿'
  } else if (absNumber >= 100000000) {
    number = number / 100000000
    unit = isHtmlUnint ? '<span class="num_unit">亿</span>' : '亿'
  } else if (absNumber >= 10000) {
    number = number / 10000
    unit = isHtmlUnint ? '<span class="num_unit">万</span>' : '万'
  }
  if (unit) {
    // 万、亿：最多保留2位
    fixLength = fixLength > 2 || fixLength < 0 ? 2 : fixLength
    number = +number.toFixed(fixLength)
  } else if (fixLength >= 0) {
    number = number.toFixed(fixLength)
  }
  number += unit
  return number
}

export function textYuan(number, isHtmlUnint) {
  return Math.abs(number) >= 10000
    ? textNumber(number, -1, !!isHtmlUnint)
    : number + (isHtmlUnint ? '<span class="num_unit">元</span>' : '元')
}

/**
 * 数字转化为字符串，万以下自动转化为带【万】【亿】单位
 * @param {number|string} rateValue 待处理数字
 * @param {number} fixLength 浮点为数精确位数，万以上的数字最多精确2位
 * @return {string}  转化后的文本数字
 */
export function htmlNumber(number, fixLength) {
  return textNumber(number, fixLength, true)
}

export function formatSI(number) {
  const num = parseInt(number, 10)
  if (!isFinite(num)) {
    return number
  }
  if (num >= 1000000000) {
    return +(num / 1000000000).toFixed(1) + 'G'
  } else if (num >= 1000000) {
    return +(num / 1000000).toFixed(1) + 'M'
  } else if (num >= 1000) {
    return +(num / 1000).toFixed(1) + 'k'
  }
  return number
}
